import { LaFilterPanelState } from '../types';
import { laFilterPanelToHash } from './laFilterPanelToHash';

/* eslint-disable @typescript-eslint/no-use-before-define */
interface CommittedState {
  hash: string;
  blocked: boolean;
  committedSearchProps: LaFilterPanelState;
}

export const laFilterPanelChangeManager = laFilterPanelChangeManagerFn();

function laFilterPanelChangeManagerFn() {
  let onSubmitBlocked = () => {};
  const committedState: CommittedState = {
    hash: '',
    blocked: true,
    committedSearchProps: {
      nodesValue: [],
      idType: '',
      value: '',
      hop: '',
      maxIpConnections: '',
    },
  };

  return {
    isSubmittable,
    commitSearchProps,
    setSubmitBlocked,
    setOnSubmitBlocked,
  };

  function commitSearchProps(searchProps: LaFilterPanelState) {
    committedState.hash = getHash(searchProps);
    committedState.committedSearchProps = searchProps;
  }

  function setSubmitBlocked(blocked: boolean) {
    committedState.blocked = blocked;
    onSubmitBlocked();
  }

  function setOnSubmitBlocked(callback: typeof onSubmitBlocked) {
    onSubmitBlocked = callback;
  }

  function isSubmittable(searchProps: LaFilterPanelState) {
    if (committedState.blocked) {
      return false;
    }

    return hasChanged(searchProps);
  }

  function getHash(state: LaFilterPanelState) {
    return laFilterPanelToHash(state, 0);
  }

  function hasChanged(state: LaFilterPanelState) {
    const hash = getHash(state);
    return hash !== committedState.hash;
  }
}
